// This is nextgtrgod's api key from his react-forecast app
export const apiKey = '77e577e4c9e13e85b8e39f71194aea31';
